import type { CardProps } from 'src/notifications/cardTypes';
import { formatShortDate } from 'src/utils/dateFormatting';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';
import PrepWithSiestaButton from '../PrepWithSiestaButton';

export default function SuitabilityReviewDueCard({
  notification,
  payload,
  onClose,
}: CardProps<'SUITABILITY_REVIEW_DUE'>) {
  return (
    <NotificationCardShell
      notification={notification}
      title="Suitability review due"
      body="A suitability review is due."
      clientId={payload.client_id}
      details={
        <NotificationDetailRow
          label="Last review"
          value={
            payload.last_review_at ? formatShortDate(payload.last_review_at) : 'Never reviewed'
          }
        />
      }
      actions={
        <>
          <NotificationLinkButton to={`/client/${payload.client_id}`} onClose={onClose}>
            View
          </NotificationLinkButton>
          <NotificationLinkButton
            to={`/client/${payload.client_id}/suitability-report`}
            onClose={onClose}
          >
            Generate
          </NotificationLinkButton>
          <PrepWithSiestaButton
            notification={notification}
            clientId={payload.client_id}
            onClose={onClose}
          />
        </>
      }
    />
  );
}
